import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { fetchTenantBootstrap } from "@/services/api/tenants";

/**
 * The public bootstrap of the school in the address (same query key and fn as the tenant layout,
 * so it is one request). `termsDraft` / `aiTutorEnabled` come from the school's settings row.
 */
export function useSchoolBootstrap(slugOverride?: string) {
  const { tenantSlug = "" } = useParams<{ tenantSlug: string }>();
  const slug = slugOverride ?? tenantSlug;
  const query = useQuery({
    queryKey: ["tenant-bootstrap", slug],
    queryFn: () => fetchTenantBootstrap(slug),
    enabled: Boolean(slug),
  });
  return { ...query, tenant: query.data?.tenant ?? null };
}
